var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-data-graph"},[_c('div',{ref:"chart",staticStyle:{"width":"600px","height":"400px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }